import angular from 'angular'
import receiveBranchInvoiceService from 'receiveBranchInvoiceService'
import receiveBranchInvoiceCtrl from './receiveBranchInvoiceCtrl'
import modalReceiveInvoiceCtrl from './modalReceiveInvoiceCtrl'
import routerConf from './Routers'
import { receiveBranchInvoice } from 'redevConfig'

const list = (receiveBranchInvoice && receiveBranchInvoice.list) || ''
const receiveBranchInvoiceListCtrl = list ? require(`redevelopment/outputManage/receiveBranchInvoice/${list.controllerName}`) : require('./receiveBranchInvoiceListCtrl')
export default angular
    .module('outputManage.stock.receiveBranchInvoice', [])
    .config(['$stateProvider', routerConf])
    .controller('receiveBranchInvoiceCtrl', receiveBranchInvoiceCtrl)
    .controller('receiveBranchInvoiceListCtrl', receiveBranchInvoiceListCtrl.default)
    .controller('modalReceiveInvoiceCtrl', modalReceiveInvoiceCtrl)
    .service('receiveBranchInvoiceService', receiveBranchInvoiceService)
    /*.filter('invoiceType', () => (type) => {
        type = Number(type)
        switch (type) {
            case 2:
                return '增值税普通发票'
            case 41:
                return '增值税普通发票(卷票)'
            case 0:
                return '增值税专用发票'
            case 51:
                return '增值税电子普通发票'
            case 11:
                return '机动车销售统一发票'
            case 42:
                return '二手车销售统一发票'
            case 12:
                return '机动车发票'
            default:
                return ''
        }
    })
    .name*/
    .filter('openApiInvoiceType', () => (type) => {
        type = Number(type)
        switch (type) {
            case 1:
                return '专用发票'
            case 2:
                return '普通发票'
            case 3:
                return '机动车发票'
            case 4:
                return '卷式发票'
            case 5:
                return '电子普通发票'
            case 6:
                return '电子专用发票'
            case 7:
                return '二手车'
            default:
                return ''
        }
    })
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/receiveBranchInvoice/index.js